import React, { useEffect } from 'react'
import UserHeader from './UserHeader'
import ContactReligionForm from './ContactReligionForm'
import UserFooter from './UserFooter'

function ContactReligion() {
  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     localStorage.removeItem('token'); 
  //   };

  //   window.addEventListener('beforeunload', handleBeforeUnload);

  //   // Cleanup function to remove the event listener
  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, []);
  // window.onbeforeunload = () => {
  //   localStorage.clear();
  // }
  return (
    <div className='formBody'>
      <UserHeader />
      <ContactReligionForm />
      <UserFooter />
    </div>
  )
}

export default ContactReligion